<template>
  <a-card :bordered="false">

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus">添加</a-button>
    </div>


    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" >编辑</a>
        </span>


      </a-table>
    </div>
    <!-- table区域-end -->
    <merchantservice-modal ref="modalForm" @ok="modalFormOk"></merchantservice-modal>

  </a-card>
</template>

<script>
  import MerchantserviceModal from './modules/MerchantserviceModal'
  import {getFileAccessHttpUrl} from '@/api/manage';
  import {ListMixin} from '@/mixins/ListMixin'
  import {filterObj} from '@/utils/util';
  import Vue from 'vue'
  import {ACCESS_TOKEN } from "@/store/mutation-types"

  export default {
    name: "MerchantList",
    mixins: [ListMixin],
    components: {
      MerchantserviceModal
    },
    data() {
      return {
        description: '商户管理',
        queryParam: {},
        columns: [
          {
            title: '商户号',
            align:"left",
            dataIndex: 'merchantId',
          },
          {
            title: '主账号',
            dataIndex: 'mainAccount',
            align:"center",
          },
          {
            title: '冻结账号',
            dataIndex: 'freezeAccount',
            align:"center",
          },
          {
            title: '支付费率*100(%)',
            dataIndex: 'payFeeRate',
            align:"center",
          },
          {
            title: '代付手续费*100',
            dataIndex: 'agentpayFee',
            align:"center",
          },
          {
            title: '币种',
            dataIndex: 'currency',
            align:"center",
          },
          {
            title: '通道',
            dataIndex: 'channelName',
            align:"center",
          },
          {
            title: '创建时间',
            dataIndex: 'createDate',
            align:"center",
          },
          {
            title: '操作',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 170
          }
        ],
        url: {
          list: "/sys/merchant/merchantServiceList",
        },
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      getQueryParams(){
        var param = Object.assign({}, this.queryParam,this.isorter);
        param.token = Vue.ls.get(ACCESS_TOKEN);
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        if (this.superQueryParams) {
          param['superQueryParams'] = encodeURI(this.superQueryParams)
          param['superQueryMatchType'] = this.superQueryMatchType
        }
        return filterObj(param);
      },
      handleFrozen: function (id, status, username) {
        let that = this;
        //TODO 后台校验管理员角色
        if ('admin' == username) {
          that.$message.warning('管理员账号不允许此操作！');
          return;
        }

      },
      handleChangePassword(username) {
        this.$refs.passwordmodal.show(username);
      },
      passwordModalOk() {
        //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
      }
    }

  }
</script>